import { addDataLayerEntry } from '@printdeal/data-layer-manager';
import { PayloadForDataLayerOnSupplementalBanner } from './helper';
import { HomePageBannerData } from '../types';

const dispatchDataLayerEventOnSupplementalBannerGA4 = (
  eventName: string,
  audienceType: string | null | undefined,
  bannerTitle: string,
  position: number,
) => {
  const contentType = 'non-personalized';
  const audience = audienceType || 'non-recognized';
  addDataLayerEntry(
    eventName,
    {
      content_type: contentType,
      audience_type: audience,
      banner_title: bannerTitle,
      position,
    },
  );
};

const dispatchDataLayerEventOnSupplementalBannerOnViewGA4 = (
  payload: PayloadForDataLayerOnSupplementalBanner[],
  eventName: string,
) => {
  const items = payload.map((item) => ({
    content_type: 'non-personalized',
    audience_type: item.audienceType === 'no_audience' ? 'non-recognized' : item.audienceType,
    banner_title: item.bannerTitle,
    index: item.index,
  }));
  addDataLayerEntry(
    eventName,
    {
      items,
      eventNonInteraction: true,
    },
  );
};

export const handleSupplementalBannerClick = (
  audienceType: string | null | undefined,
  bannerTitle: string,
  position: number,
) => {
  dispatchDataLayerEventOnSupplementalBannerGA4('supplemental_banner_click', audienceType, bannerTitle, position);
};

export const handleEventOnSupplementalBannerOnViewVariantGA4 = (
  audienceType: string | null | undefined,
  payload: HomePageBannerData[] | undefined,
) => {
  const payloadForDataLayer: PayloadForDataLayerOnSupplementalBanner[] = [];
  payload?.forEach((item, index) => (
    payloadForDataLayer.push({
      eventName: 'supplemental_banner_view',
      index: index + 1,
      audienceType,
      bannerTitle: item.displayTitle || '',
    })
  ));
  dispatchDataLayerEventOnSupplementalBannerOnViewGA4(payloadForDataLayer, 'supplemental_banner_view');
};
